import { classNames } from "primereact/utils";
import styles from "./index.module.css";

export default function HeaderWithLeaf({ text, textAlign }) {
  if (!text) return null;

  const trimmedText = text.trim(); // Trim leading/trailing whitespace
  const firstLetter = trimmedText[0]; // First character
  const remainingText = trimmedText.slice(1); // Remaining string

  return (
    <div
      className={classNames(
        styles.headerContainer,
        { [styles.leftAligned]: textAlign === "left" },
        "mb-4"
      )}
    >
      <h2 className={classNames(styles.heading, "mb-0")}>
        <span className={styles.firstLetterWrapper}>
          {firstLetter}
          <img
            className={styles.leafIcon}
            src={"./assets/images/home/leaf-1-1 1.webp"}
            alt="leaf"
            loading="lazy"
          />
        </span>
        {remainingText}
      </h2>
    </div>
  );
}
